
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsVatRefundDialog extends Serenity.EntityDialog<PsVatRefundRow, any> {
        protected getFormKey() { return PsVatRefundForm.formKey; }
        protected getIdProperty() { return PsVatRefundRow.idProperty; }
        protected getLocalTextPrefix() { return PsVatRefundRow.localTextPrefix; }
        protected getNameProperty() { return PsVatRefundRow.nameProperty; }
        protected getService() { return PsVatRefundService.baseUrl; }
        protected getDeletePermission() { return PsVatRefundRow.deletePermission; }
        protected getInsertPermission() { return PsVatRefundRow.insertPermission; }
        protected getUpdatePermission() { return PsVatRefundRow.updatePermission; }

        protected form = new PsVatRefundForm(this.idPrefix);

        constructor() {
            super();

            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
                this.calcDataOnGrid();
            });


            this.form.RefFg.change(e => {
                let orderNo = this.form.RefFg.value
                if (!Q.isEmptyOrNull(orderNo)) {

                    this.form.RefNo.value = null;

                    // pass value into lookup editor and update items
                    this.form.RefNo.myId = orderNo;
                    this.form.RefNo.myId2 = this.form.ShopId.value;
                    this.form.RefNo.updateItems();

                    // select first lookup item after changing
                    // if (this.form.DocNo.items && this.form.DocNo.items.length > 0) {
                    //     // Serenity.EditorUtils.setValue(this.form.DocNo, this.form.DocNo.items[0].id);
                    // }               


                }
            });

            this.form.Passport.change(e => {
                let Passport: string = this.form.Passport.value
                if (!Q.isEmptyOrNull(Passport)) {
                    var id = Q.tryFirst(GeniuzPOS.PosShift.LookupLastPassportDataforVatRefundRow.getLookup().items, x => x.Passport == Passport)
                    if (id != null) {
                        this.form.Country.value = id.Country ?? "";
                        this.form.Nation.value = id.Nation ?? "";
                        this.form.FristName.value = id.FristName ?? "";
                        this.form.LastName.value = id.LastName ?? "";
                        this.form.Addressno.value = id.Addressno ?? "";
                        this.form.Street.value = id.Street ?? "";
                        this.form.District.value = id.District ?? "";
                        this.form.City.value = id.City ?? "";
                        this.form.Province.value = id.Province ?? "";
                        this.form.ZipCode.value = id.ZipCode ?? "";
                        this.form.Email.value = id.Email ?? "";
                    }
                } else {

                }
            });


            this.form.Country.change(e => {
                let Country = this.form.Country.value
                if (!Q.isEmptyOrNull(Country)) {
                    if (Q.isEmptyOrNull(this.form.Nation.value)) {
                        this.form.Nation.value = Country
                    }
                    Serenity.EditorUtils.setReadOnly(this.form.Nation, false);
                } else {
                    this.form.Nation.value = null;
                    Serenity.EditorUtils.setReadOnly(this.form.Nation, true);
                }
            });



        }

        private calcDataOnGrid() {
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;

                for (var i of this.form.DtList.getItems()) {
                    VatAmt += i.ItemVat || 0;
                    totalAmt += i.Amt || 0;

                }

                this.form.Total.value = totalAmt;
                this.form.Vat.value = VatAmt;
                this.checkvateround();

            });

            (this.form.DtList.view as any).onRowCountChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;
                for (var i of this.form.DtList.getItems()) {
                    VatAmt += i.ItemVat || 0;
                    totalAmt += i.Amt || 0;

                }

                this.form.Total.value = totalAmt;
                this.form.Vat.value = VatAmt;
                this.checkvateround();

            });

        }

        private checkvateround() {
            let totalAmt = this.form.Total.value
            let Vat = this.form.Vat.value

            let t = Q.tryFirst(PosShift.PsVatRefundRateRow.getLookup().items, x => x.PurchaseFrom <= totalAmt && (x.PurchaseTo >= totalAmt || x.PurchaseTo == null));

            if (t != null) {
                this.form.VatRateNo.value = t.VatRateNo;
                if (t.RefundFg == 0) {
                    this.form.RoundedVatRefund.value = t.RoundedRefund;
                    if (Vat >= t.RoundedRefund) {
                        this.form.PayVatAmount.value = t.RoundedRefund
                    } else {
                        this.form.PayVatAmount.value = Vat
                    }

                } else {
                    this.form.RoundedVatRefund.value = (t.RefundPc * totalAmt) / 100;
                    this.form.PayVatAmount.value = (t.RefundPc * totalAmt) / 100;
                }
            } else {
                this.form.RoundedVatRefund.value = 0;
                this.form.PayVatAmount.value = 0;
            }
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();


            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            let send: Serenity.ToolButton =
                {
                    title: "CONFRIM",
                    hint: "confrim save",
                    separator: false,
                    cssClass: "button-confrim",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        
                        if (Q.isEmptyOrNull(this.form.DocNo.value)) {
                            this.getNextNumber();
                        }else{
                            // this.form.DocNo.value = this.form.DocNo.value
                        }

                        // this.disamtalocate()
                        if (!Q.isEmptyOrNull(this.form.DocNo.value)) {

                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    var a = this.loadById(id1);
                                }
                                else {
                                    var a = this.loadById(response.EntityId);
                                }

                                Q.confirm('ยืนยันส่งอนุมัติเอกสาร'
                                    , () => {
                                        this.form.Status.value = 1;


                                        var options = this.getSaveOptions((respons2) => {

                                            if (this.isEditMode()) {
                                                var id1 = respons2.EntityId;
                                                if (id1 == null) {
                                                    id1 = this.get_entityId();
                                                }
                                                this.loadById(id1);
                                            }
                                            else {
                                                this.loadById(respons2.EntityId);
                                                // this.dialogClose();
                                            }

                                            this.showSaveSuccessMessage(respons2);


                                        });



                                        options.onError = function (respons2) {
                                            Q.alert(respons2.Error.Message);
                                        }

                                        Q.serviceCall(options);




                                    });


                            });

                            options.onError = function (response) {
                                Q.alert(response.Error.Message);
                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                    }
                };buttons.push(send);

            if (!this.isNew()) {
                console.log("isEdit"+this.form.Status.value)
                if (this.form.Status.value == 1) {
                    buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                    this.toolbar.findButton('button-confrim').hide();
                } else {
                
                
            }
        }else{
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            }


                let newSaveBtn: Serenity.ToolButton =
    {
        title: "SAVE",
        hint: "Save",
        separator: false,
        cssClass: "button-save",
        icon: "fa fa-save",
        hotkey: 'alt+s',
        onClick: (e) => {

            var self = this;
            if (Q.isEmptyOrNull(this.form.DocNo.value)) {
                this.getNextNumber();
            }else{
                
            }

            // this.disamtalocate()
            if (!Q.isEmptyOrNull(this.form.DocNo.value)) {


            if (this.validateForm() && this.validateBeforeSave()) {
                var options = this.getSaveOptions((response) => {

                    if (this.isEditMode()) {
                        var id1 = response.EntityId;
                        if (id1 == null) {
                            id1 = this.get_entityId();
                        }
                        this.loadById(id1);
                    }
                    else {
                        if (this.isNew()) {
                            this.loadById(response.EntityId);
                        } else {
                            this.loadById(response.EntityId);

                        }
                    }

                    this.showSaveSuccessMessage(response);


                });

                options.onError = function (response) {
                    if (response.Error.Message.includes("Can't save record. There is another record")) {
                        Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                        var s = self.form.DocNo.value
                        var f = s.substring(0, 9)
                        GeniuzPOS.PosShift.PsVatRefundService.GetNextNumber({
                            Prefix: f,
                            Length: 16
                        }, response => {

                            self.form.DocNo.value = response.Serial;

                        });
                    } else { Q.alert(response.Error.Message); }



                }

                Q.serviceCall(options);
            } else {
                this.save((response) => {
                    this.dialogClose();
                });


            }

        }
        }
    };
    buttons.push(newSaveBtn);



    buttons.push(
        {
            title: Q.text("Close"),	// *** Get button text from translation
            cssClass: '.panel-titlebar-close',
            icon: 'fa-close',
            hint: 'esc',
            hotkey: 'esc',
            onClick: () => {
                this.dialogClose();

            },
        }
    );


    let CallPR: Serenity.ToolButton =
    {
        title: "",
        hint: "call list",
        cssClass: "call",
        icon: "fa fa-level-down-alt",

        onClick: (e) => {

            let doc = this.form.RefNo.value
            let fg = this.form.RefFg.value

            if (!Q.isEmptyOrNull(doc)) {
                if (fg == "0") {

                    var id = Q.tryFirst(GeniuzPOS.PosShift.PosTranHdRow.getLookup().items, x => x.DocNo == doc).DocNo;

                    PosTranHdService.Retrieve(
                        {
                            EntityId: id
                        }, response => {
                            this.setHdDetails(response.Entity);
                            this.form.DtList.CallPR = doc;

                        }
                    )

                } else {
                    var id = Q.tryFirst(GeniuzPOS.PosShift.PsTaxInvoiceHdRow.getLookup().items, x => x.DocNo == doc).DocNo;

                    PsTaxInvoiceHdService.Retrieve(
                        {
                            EntityId: id
                        }, response => {
                            this.setTaxDetails(response.Entity);
                            this.form.DtList.CallTAX = doc;

                        }
                    )
                }


            }

        }
    };
    buttons.push(CallPR);


    let delPR: Serenity.ToolButton =
    {
        title: "",
        hint: "delete list",
        cssClass: "del",
        icon: "fa fa-ban text-red",

        onClick: (e) => {

            let doc = this.form.RefNo.value
            let fg = this.form.RefFg.value

            if (!Q.isEmptyOrNull(doc)) {
                if (fg == "0") {
                    this.form.DtList.delPR = doc;

                } else {
                    this.form.DtList.delTAX = doc;


                }
            }

        }
    };
    buttons.push(delPR);

    return buttons;

}

        public setHdDetails(details: PosTranHdRow) {


}

        public setTaxDetails(details: PsTaxInvoiceHdRow) {
    //hd

    this.form.Remark.value = String(details.Remark ?? "");
    this.form.ZipCode.value = String(details.TaxPostalCode ?? "");
    this.form.Email.value = String(details.TaxEmail ?? "");
    this.form.Country.value = String(details.TaxCountryCode ?? "");


}

        private getNextNumber() {
    var val = Q.trimToNull(this.form.DocNo.value);



    // if (!val || val.length <= 3) {
        var someDate = new Date();
        var dd = someDate.getDate();
        var mm = someDate.getMonth() + 1;
        var myRow = 0;
        var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
        console.log('User Id : ' + userId.ShopId);

        // this.form.ShopId.value = userId.ShopId
        try {
            var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

            if (userRole != null) {
                myRow = userRole.RoleId;
            }
            if (userRole != null || userRole.RoleId.valueOf) {
                myRow = userRole.RoleId;
            }
            if (myRow == 1) {
                //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
            }
        } catch {

        }

        var y = someDate.getFullYear();
        // var mo = "";
        // var ddd = "";

        // if (mm < 10) {
        //     mo = '0' + mm;

        // } else {
        //     mo = mm.toString();
        // }

        // if (dd < 10) {
        //     //ddd = '0' + dd;
        //     ddd = '';

        // } else {
        //     //ddd = dd.toString();
        //     ddd = '';
        // }

        var year = y.toString().substr(2, 2);
        var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "26").DocPrefix
        console.log("docprefix" + docprefix)
        if (docprefix == null) {
            docprefix = "VF"
        }


        var prefix = docprefix + userId.ShopId + year;
        GeniuzPOS.PosShift.PsVatRefundService.GetNextNumber({
            Prefix: prefix,
            Length: 16
        }, response => {

            this.form.DocNo.value = response.Serial;
            // this.form.DocDate.element.focus();
        });
    // }

}

        protected afterLoadEntity() {
    super.afterLoadEntity();

    // this.waning = false;
    // this.hideadd(1);
    this.form.DtList.myPassValue = this.form.DocNo.value
    // this.form.DtList.doctype = Number(this.form.DocType.value)
    // this.form.DtList.salevattype = this.form.SalesVatType.value


    if (this.isNew()) {

        var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
        console.log('User Id : ' + userId.ShopId);
        this.form.ShopId.value = userId.ShopId
        this.form.DtList.shopid = userId.ShopId

        this.getNextNumber();
        this.form.RefNo.myId = "0";
        this.form.RefNo.myId2 = userId.ShopId;
        this.form.RefNo.updateItems();

        this.toolbar.findButton('delete-button').hide();
        this.toolbar.findButton('apply-changes-button').hide();
        // this.form.RefDocNo.element.toggleClass("required", true);

    }

    this.toolbar.findButton('del').insertAfter(this.form.RefNo.element)
    this.toolbar.findButton('call').insertAfter(this.form.RefNo.element)




    ////----
    let self = this;
    let nbrRetry = 0;
    (function changeTitle() {
        if (nbrRetry >= 10) {
            return;
        }

        setTimeout(() => {
            if ((self as any).isMarkedAsPanel === true) {
                if (self.element.find(".panel-titlebar").length == 1) {
                    // self.element.find(".panel-titlebar").html("");
                    //self.element.find(".panel-titlebar-text").html("");
                    self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                }
                else {
                    changeTitle();
                }
            }
            else {
                if (self.element.parent().find(".panel-titlebar").length == 1) {
                    // self.element.parent().find(".panel-titlebar").html("");
                    // self.element.parent().find(".panel-titlebar-text").html("");
                    self.element.parent().find(".panel-titlebar-close").html("");
                }
                else {
                    changeTitle();
                }
            }
        }, 100);
    })();
    if (this.entity.Status == 1) {
        this.Readonlyafterapp();
        this.toolbar.findButton('button-confrim').hide();
        this.toolbar.findButton('apply-changes-button').hide();
                    

    }
    

}

        private Readonlyafterapp(){

    Serenity.EditorUtils.setReadOnly(this.form.BookNo, true);
    Serenity.EditorUtils.setReadOnly(this.form.DocNo, true);
    Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
    Serenity.EditorUtils.setReadOnly(this.form.ShopId, true);
    Serenity.EditorUtils.setReadOnly(this.form.No, true);
    Serenity.EditorUtils.setReadOnly(this.form.Total, true);
    Serenity.EditorUtils.setReadOnly(this.form.RefFg, true);
    Serenity.EditorUtils.setReadOnly(this.form.RefNo, true);
    Serenity.EditorUtils.setReadOnly(this.form.Passport, true);
    Serenity.EditorUtils.setReadOnly(this.form.Country, true);
    Serenity.EditorUtils.setReadOnly(this.form.Nation, true);
    Serenity.EditorUtils.setReadOnly(this.form.FristName, true);
    Serenity.EditorUtils.setReadOnly(this.form.LastName, true);
    Serenity.EditorUtils.setReadOnly(this.form.IssueName, true);
    Serenity.EditorUtils.setReadOnly(this.form.IssueByDate, true);

    Serenity.EditorUtils.setReadOnly(this.form.FlightNo, true);
    Serenity.EditorUtils.setReadOnly(this.form.ArriveDate, true);
    Serenity.EditorUtils.setReadOnly(this.form.DepartureDate, true);
    Serenity.EditorUtils.setReadOnly(this.form.Addressno, true);
    Serenity.EditorUtils.setReadOnly(this.form.Street, true);
    Serenity.EditorUtils.setReadOnly(this.form.District, true);
    Serenity.EditorUtils.setReadOnly(this.form.City, true);
    Serenity.EditorUtils.setReadOnly(this.form.Province, true);
    Serenity.EditorUtils.setReadOnly(this.form.ZipCode, true);
    Serenity.EditorUtils.setReadOnly(this.form.Email, true);
    Serenity.EditorUtils.setReadOnly(this.form.DtList, true);
    Serenity.EditorUtils.setReadOnly(this.form.Remark, true);


    this.toolbar.findButton('apply-changes-button').hide();
    this.toolbar.findButton('save-and-close-button').hide();
    this.toolbar.findButton('delete-button').hide();
    this.toolbar.findButton('button-confrim').hide();
    this.toolbar.findButton('button-save').hide();


}



    }
}